export const footerLinks = [
  { label: 'Terms', to: '/terms-and-conditions' },
  { label: 'Privacy', to: '/privacy-policy' },
  { label: 'Cookies', to: '/cookie-policy' },
];
